/**
 * Represents an empty array.
 * 
 * @type {ReadonlyArray<any>}
 */
export const EMPTY_ARRAY: ReadonlyArray<any> = new Array<any>();
